import z from "zod";

// Response from GET /settings. The backend returns every setting the user has a
// row for, as a flat key/value map; a key with no row is simply absent.
export const SettingsResponseSchema = z.object({
  settings: z.record(z.string(), z.string()),
});

// Body for POST /settings (create) and PUT /settings (update). The backend has
// no upsert: PUT 404s when the key has no row yet, so a caller that doesn't know
// whether the row exists reads GET /settings first.
export const SettingInputSchema = z.object({
  key: z.string(),
  value: z.string(),
});

// Body for DELETE /settings. Only the key identifies the row to remove; the
// delete is idempotent, so a key with no row still succeeds.
export const SettingKeyInputSchema = z.object({
  key: z.string(),
});
